module.exports = function getResource(label) {
    let resources = {
        pickupNotOffered: ' - Pickup not offered',
        openUntil: 'Open until ',
        closed: 'Closed',
        milesAway: ' miles away',
        inStock: 'In Stock',
        outOfStock: 'Out of Stock',
        limitedStock: 'Limited Stock',
        payInStore: 'Pay in Store',
        payOnline: 'Pay Online'
    };

    return resources[label];
};
